import { Pipe, PipeTransform, TrackByFunction } from '@angular/core';
import { ItemProfile, ItemProperties, ItemResource, PropertyProfile } from '@ngx-hal/models';

@Pipe({
  name: 'trackPropertyBy',
  standalone: false
})
export class TrackPropertyByPipe implements PipeTransform {
  private itemProfile?: ItemProfile<never>;
  private trackPropertyBy?: TrackByFunction<never>;

  /**
   * Transforms an `ItemProfile` into a `TrackByFunction` for use in Angular's `*ngFor` directive.
   * The returned function generates a unique tracking key for each property based on the ALPS profile ID and property name.
   * If the provided `itemProfile` differs from the previously stored profile (by ALPS href), the tracking function is updated.
   * Falls back to using the index as the tracking key if no profile is available.
   *
   * @typeParam Entity - The type of the item resource.
   * @param itemProfile - The profile of the item containing ALPS metadata.
   * @returns A `TrackByFunction` that generates a unique key for each property in the profile.
   */
  transform<Entity extends ItemResource>(
    itemProfile: ItemProfile<Entity>,
  ): TrackByFunction<PropertyProfile<Entity, ItemProperties<Entity>>> {
    if (this.itemProfile?.alps.href !== itemProfile?.alps?.href) {
      this.itemProfile = itemProfile;
      this.trackPropertyBy = (_: number, property: PropertyProfile<Entity, ItemProperties<Entity>>) =>
        `${itemProfile.alps.id ?? ''}.${property.alps.name}`;
    }

    return this.trackPropertyBy ?? ((index: number) => index);
  }
}
